/* Smooth (AJAX) filtering for the collection grid.
   Filter checkboxes apply as soon as they change, price applies on change,
   and chip, clear, pagination and sort controls refresh in place. Each
   refresh asks Shopify's Section Rendering API for this section only (the
   same URL plus section_id), so locale, currency, filters, tag segment and
   sort all come from the real URL. The address bar always holds the
   shareable URL, and back/forward restore it. Without JS, or on any error,
   the links and the Apply button work as normal page loads. */
(function () {
  function initCollection(section) {
    if (!section || section.__bsAjaxFilters) return;
    section.__bsAjaxFilters = true;

    var sectionId = section.getAttribute('data-section-id');
    var desktopQuery = window.matchMedia('(min-width: 990px)');
    var cache = {};
    var controller = null;
    var debounceTimer = null;

    var live = document.createElement('p');
    live.className = 'visually-hidden';
    live.setAttribute('aria-live', 'polite');
    section.parentNode.insertBefore(live, section.nextSibling);

    function markEnhanced() {
      section.classList.add('bs-collection--js');
      Array.prototype.slice.call(section.querySelectorAll('[data-bs-filters-done], .bs-collection__sheet-close')).forEach(function (button) {
        button.hidden = false;
      });
      var sort = section.querySelector('.bs-collection__sort');
      if (sort) sort.onchange = null;
    }

    function openGroupKeys() {
      return Array.prototype.slice.call(section.querySelectorAll('.bs-filter-group, .bs-filter-more'))
        .filter(function (details) { return details.open; })
        .map(function (details) { return details.getAttribute('data-bs-filter'); });
    }

    function currentDrawer() {
      return section.querySelector('[data-bs-filters-drawer]');
    }

    function sectionUrl(path) {
      var target = new URL(path, window.location.href);
      target.searchParams.set('section_id', sectionId);
      return target.toString();
    }

    function cleanPath(url) {
      var target = new URL(url, window.location.href);
      target.searchParams.delete('section_id');
      return target.pathname + target.search;
    }

    function restore(state) {
      Array.prototype.slice.call(section.querySelectorAll('.bs-filter-group, .bs-filter-more')).forEach(function (details) {
        if (state.openKeys.indexOf(details.getAttribute('data-bs-filter')) !== -1) details.open = true;
      });
      var drawer = currentDrawer();
      if (drawer) {
        if (desktopQuery.matches || state.drawerOpen) {
          drawer.setAttribute('open', '');
        } else {
          drawer.removeAttribute('open');
        }
      }
      if (state.focusId) {
        var focusTarget = document.getElementById(state.focusId);
        if (focusTarget && !focusTarget.disabled) focusTarget.focus({ preventScroll: true });
      }
      markEnhanced();
      applyCheckerRank();
      var count = section.querySelector('[data-bs-results-count]');
      if (count) live.textContent = count.textContent.replace(/\s+/g, ' ').trim() + ' shown';
    }

    function render(html, state) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('section.bs-collection');
      if (!fresh) throw new Error('Section missing in response');
      section.innerHTML = fresh.innerHTML;
      restore(state);
    }

    function swap(url, push) {
      var path = cleanPath(url);
      var drawer = currentDrawer();
      var active = document.activeElement;
      var state = {
        openKeys: openGroupKeys(),
        drawerOpen: drawer ? drawer.open : false,
        focusId: active && section.contains(active) && active.id ? active.id : ''
      };

      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      section.classList.add('bs-collection--loading');

      var request = cache[path]
        ? Promise.resolve(cache[path])
        : fetch(sectionUrl(path), {
          credentials: 'same-origin',
          signal: controller ? controller.signal : undefined
        }).then(function (response) {
          if (!response.ok) throw new Error('Filter fetch failed');
          return response.text();
        });

      request
        .then(function (html) {
          cache[path] = html;
          render(html, state);
          if (push) history.pushState({ bsCollectionFilters: true }, '', path);
          window.requestAnimationFrame(function () {
            section.classList.remove('bs-collection--loading');
          });
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          window.location.href = path;
        });
    }

    function buildFormUrl(form) {
      var pairs = [];
      new FormData(form).forEach(function (value, key) {
        if (value !== '') pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      return window.location.pathname + (pairs.length ? '?' + pairs.join('&') : '');
    }

    function scrollToResults() {
      var main = section.querySelector('.bs-collection__main');
      if (!main) return;
      var top = main.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    function closeSheet(focusToggle) {
      var drawer = currentDrawer();
      if (!drawer || desktopQuery.matches) return;
      drawer.removeAttribute('open');
      if (focusToggle) {
        var toggle = drawer.querySelector('summary');
        if (toggle) toggle.focus();
      }
    }

    // On phones and tablets the open drawer is a modal bottom sheet: lock the
    // page behind it and move focus into it. 'toggle' does not bubble, so
    // listen in the capture phase to survive section swaps.
    section.addEventListener('toggle', function (event) {
      var drawer = event.target;
      if (!drawer.matches || !drawer.matches('[data-bs-filters-drawer]')) return;
      var sheetOpen = drawer.open && !desktopQuery.matches;
      document.documentElement.classList.toggle('bs-sheet-open', sheetOpen);
      var active = document.activeElement;
      if (sheetOpen && !(active && active.closest('.bs-collection__sidebar-inner'))) {
        var close = drawer.querySelector('.bs-collection__sheet-close');
        if (close) close.focus({ preventScroll: true });
      }
    }, true);

    section.addEventListener('click', function (event) {
      if (event.target.closest('[data-bs-filters-close]')) {
        closeSheet(true);
        return;
      }

      if (event.target.closest('[data-bs-filters-done]')) {
        closeSheet(false);
        var main = section.querySelector('.bs-collection__main');
        if (main) main.focus({ preventScroll: true });
        scrollToResults();
        return;
      }

      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      var link = event.target.closest('a[href]');
      if (!link || !section.contains(link)) return;

      var inPagination = !!link.closest('.bs-collection__pagination');
      var isFilterLink = inPagination
        || link.classList.contains('bs-collection__clear')
        || link.classList.contains('bs-collection__active-filter')
        || link.classList.contains('bs-quick-filter')
        || !!link.closest('.bs-collection__empty');
      if (!isFilterLink) return;

      event.preventDefault();
      swap(link.getAttribute('href'), true);
      if (inPagination) scrollToResults();
    });

    section.addEventListener('submit', function (event) {
      var form = event.target;
      if (form.id !== 'CollectionFiltersForm') return;
      event.preventDefault();
      window.clearTimeout(debounceTimer);
      swap(buildFormUrl(form), true);
    });

    section.addEventListener('change', function (event) {
      var target = event.target;
      if (target.classList.contains('bs-collection__sort')) {
        if (target.form) swap(buildFormUrl(target.form), true);
        return;
      }
      var form = target.form;
      if (!form || form.id !== 'CollectionFiltersForm') return;
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () {
        swap(buildFormUrl(form), true);
      }, target.type === 'checkbox' ? 200 : 0);
    });

    section.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || desktopQuery.matches) return;
      var drawer = currentDrawer();
      if (drawer && drawer.open) closeSheet(true);
    });

    function applyCheckerRank() {
      if (!/[?&]bs_ranked=1/.test(window.location.search)) return;
      var payload = null;
      try {
        payload = JSON.parse(window.sessionStorage.getItem('blusafeCheckerRank') || 'null');
      } catch (error) {
        return;
      }
      var handles = payload && payload.handles;
      if (!handles || !handles.length) return;

      var grid = section.querySelector('.bs-collection__grid');
      if (!grid) return;

      function handleOf(card) {
        var link = card.matches && card.matches('a[href*="/products/"]') ? card : card.querySelector && card.querySelector('a[href*="/products/"]');
        var match = link && (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        return match ? decodeURIComponent(match[1]) : '';
      }

      var cards = Array.prototype.slice.call(grid.children).filter(function (child) {
        return handleOf(child) !== '';
      });
      if (!cards.length) return;

      var ranked = cards.slice().sort(function (a, b) {
        var indexA = handles.indexOf(handleOf(a));
        var indexB = handles.indexOf(handleOf(b));
        if (indexA === -1) indexA = handles.length;
        if (indexB === -1) indexB = handles.length;
        return indexA - indexB;
      });
      ranked.slice().reverse().forEach(function (card) {
        grid.insertBefore(card, grid.firstChild);
      });

      var best = ranked[0];
      if (best && handles.indexOf(handleOf(best)) === 0) {
        var badges = best.querySelector('.bs-card__badges');
        if (badges && !badges.querySelector('.bs-badge--best-match')) {
          var badge = document.createElement('span');
          badge.className = 'bs-badge bs-badge--best-match';
          badge.textContent = 'Best match';
          badges.insertBefore(badge, badges.firstChild);
        }
      }

      var bar = section.querySelector('.bs-collection__results-bar');
      if (bar && !bar.querySelector('.bs-collection__rank-note')) {
        var note = document.createElement('span');
        note.className = 'bs-collection__rank-note';
        note.textContent = 'Ordered by best match for your door';
        bar.appendChild(note);
      }
    }

    history.replaceState({ bsCollectionFilters: true }, '', window.location.pathname + window.location.search + window.location.hash);

    window.addEventListener('popstate', function (event) {
      if (event.state && event.state.bsCollectionFilters) swap(window.location.href, false);
    });

    desktopQuery.addEventListener('change', function () {
      var drawer = currentDrawer();
      if (!drawer) return;
      if (desktopQuery.matches) {
        drawer.setAttribute('open', '');
      } else {
        drawer.removeAttribute('open');
      }
      document.documentElement.classList.remove('bs-sheet-open');
    });

    markEnhanced();
    applyCheckerRank();
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('section.bs-collection')).forEach(initCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
